import { Radar } from "lucide-react";
import {
  LamaMaturityProfileParamsSchema,
  defaultLamaMaturityProfileParams,
  type LamaMaturityProfileOutput,
  type LamaMaturityProfileParams,
} from "@playbookai/widget-schemas";
import { registerWidget } from "../registry.js";
import type { SqlWidgetDef } from "../types.js";
import { LamaMaturityProfileWidget } from "./Component.js";

/**
 * LAMA Maturity Profile — dashboard-only report section (plan §13.3).
 * `TView` is the `lama/maturity-profile@1` dataset output.
 */
export const lamaMaturityProfileDef: SqlWidgetDef<
  LamaMaturityProfileParams,
  LamaMaturityProfileOutput
> = {
  kind: "lamaMaturityProfile",
  label: "Maturity Profile",
  modes: ["dashboard"],
  singleton: true,
  defaultSize: { w: 960, h: 440 },
  defaultParams: defaultLamaMaturityProfileParams,
  Component: LamaMaturityProfileWidget,
  storage: "sql",
  schema: LamaMaturityProfileParamsSchema,
  accent: "cyan",
  icon: Radar,
  subtitle: "Pillar radar with target and previous-wave overlays",
  defaultRoster: false,
  category: "single",
  layout: { col: "full", row: 2, width: 960, height: 440 },
  dashboard: {
    icon: Radar,
    defaultWidth: "full",
    category: "Operations",
    supportsTitleOverride: true,
  },
};

registerWidget(lamaMaturityProfileDef);
